// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SCzj","tabsBox":"styles_tabsBox__2B7N2","createButton":"styles_createButton__7NzQM"};